export default {
  slots: {
    identity: {
      label: "Documento d'identità",
      hint: "Carta d'identità, passaporto o permesso di soggiorno, fronte e retro. Qui vanno inseriti anche i documenti dei soci.",
    },
    trade_registration: {
      label: "Registrazione dell'attività (Gewerbeanmeldung)",
      hint: "La registrazione dell'attività ricevuta dalla camera di commercio.",
    },
    commercial_register_extract: {
      label: 'Estratto del registro delle imprese (Handelsregisterauszug)',
      hint: 'Un estratto aggiornato del registro delle imprese, se la tua attività vi è registrata.',
    },
    bank_statement: {
      label: 'Estratto conto bancario (Kontoauszug)',
      hint: "Un estratto recente del tuo conto aziendale che mostri il titolare del conto e l'IBAN.",
    },
    shareholder_list: {
      label: 'Elenco dei soci (Gesellschafterliste)',
      hint: "L'elenco aggiornato dei soci.",
      hint_gbr: 'Il tuo atto costitutivo (Gesellschaftsvertrag) o un elenco di tutti i soci.',
    },
    tax_number: {
      label: 'Codice fiscale o partita IVA (Steuernummer oder USt-IdNr.)',
      hint: "Una lettera dell'agenzia delle entrate che mostri il tuo codice fiscale, o la conferma della tua partita IVA.",
    },
  },
  tags: {
    required: 'Obbligatorio',
    optional: 'Facoltativo',
    missing: 'Mancante',
  },
  kinds: {
    passport: 'Passaporto',
    driver_license: 'Patente di guida',
    id_card: "Carta d'identità",
    residence_permit: 'Permesso di soggiorno',
  },
  holders: {
    owner: 'Titolare',
    partner: 'Socio: {{name}}',
  },
  file: {
    with_back: 'Fronte e retro',
    uploaded_at: 'Caricato il {{date}}',
    expires_at: 'Valido fino al {{date}}',
  },
  errors: {
    load: 'Impossibile caricare i documenti.',
  },
  empty: 'Nessun file ancora',
  buttons: {
    add: 'Aggiungi file',
    replace: 'Sostituisci',
    remove: 'Rimuovi',
    retry: 'Riprova',
  },
  remove_confirm: {
    title: 'Rimuovere questo file?',
    description: 'Usa questa opzione per un file caricato per errore.',
    ok: 'Rimuovi',
    cancel: 'Annulla',
  },
  toasts: {
    remove_success: 'File rimosso',
    remove_error: 'Impossibile rimuovere il file. Riprova.',
  },
};
